import React from 'react'
import styles from './getPlateWithHighLightedChars.module.css'

export const getPlateWithHighlightedChars = (
    potentialOffenderPlate: string,
    offenderPlate: string
): React.ReactNode[] => {
    try {
        const result: React.ReactNode[] = []

        // If plate is empty
        if (potentialOffenderPlate.length === 0 || offenderPlate.length === 0) {
            result.push(
                <span data-mismatch="true" className={styles.plateCharMismatch}>
                    {potentialOffenderPlate}
                </span>
            )
            return result
        }

        // if length equal, 1 to 1 check
        if (potentialOffenderPlate.length === offenderPlate.length) {
            for (let i = 0; i < potentialOffenderPlate.length; i++) {
                if (potentialOffenderPlate[i] === offenderPlate[i]) {
                    result.push(
                        <span key={i} data-mismatch="false" className={styles.plateChar}>
                            {potentialOffenderPlate[i]}
                        </span>
                    )
                } else {
                    result.push(
                        <span key={i} data-mismatch="true" className={styles.plateCharMismatch}>
                            {potentialOffenderPlate[i]}
                        </span>
                    )
                }
            }
            return result
        }

        // checks if potential offender is longer.
        const isPotentialOffenderPlateLonger = potentialOffenderPlate.length > offenderPlate.length

        if (isPotentialOffenderPlateLonger) {
            //if its longer we dont need to add ? but only mark the difference in plate numbers in red
            let offenderPlateIndex = 0
            for (let i = 0; i < potentialOffenderPlate.length; i++) {
                const potentialOffenderPlateChar = potentialOffenderPlate[i]
                const offenderChar = offenderPlate[offenderPlateIndex]

                if (potentialOffenderPlateChar === offenderChar) {
                    result.push(
                        <span key={i} data-mismatch="false" className={styles.plateChar}>
                            {potentialOffenderPlateChar}
                        </span>
                    )
                    offenderPlateIndex++
                } else {
                    result.push(
                        <span key={i} data-mismatch="true" className={styles.plateCharMismatch}>
                            {potentialOffenderPlateChar}
                        </span>
                    )
                }
            }
            // console.log(result)
            return result
        } else {
            // this is the case if potentialoffender has less characters / missing characters which a missing char is replaced by a ?
            let potentialOffenderIndex = 0
            for (let i = 0; i < offenderPlate.length; i++) {
                const offenderPlateChar = offenderPlate[i]
                const potentialOffenderPlateChar = potentialOffenderPlate[potentialOffenderIndex]

                if (offenderPlateChar === potentialOffenderPlateChar) {
                    result.push(
                        <span key={i} data-mismatch="false" className={styles.plateChar}>
                            {offenderPlateChar}
                        </span>
                    )
                    potentialOffenderIndex++
                } else {
                    result.push(
                        <span key={`missing-${i}`} data-mismatch="true" className={styles.plateCharMismatch}>
                            ?
                        </span>
                    )
                }
            }
            // console.log(result)
            return result
        }
    } catch (error) {
        return [
            <span data-mismatch="false" className={styles.plateChar} key="error">
                {potentialOffenderPlate}
            </span>
        ]
    }
}
